import { FCX } from '@core/models';
import { TextInput } from '@components/Inputs';
import { UseFormReturn } from '@core/hooks/useForm';
import { BodyUpdateSurvey } from '@core/api/useSurveys';
import { TextInputType } from '@components/Inputs/TextInput/TextInput';
import { components } from '@core/api/api';

const CONFIG: Array<{
    title: string;
    key: keyof components['schemas']['ItemsRatio'];
}> = [
    { title: 'express items:', key: 'express' },
    { title: 'Kids Express:', key: 'expressKid' },
    { title: 'full concepts:', key: 'conceptLocker' },
    { title: 'Kids Full Concepts:', key: 'conceptLockerKid' },
    { title: 'Public Items:', key: 'regular' },
    { title: 'Kids Public Items:', key: 'regularKid' },
    { title: 'Scores Plus Items:', key: 'scoresPlus' },
    { title: 'Scores Enterprise Items:', key: 'scoresEnterprise' },
];

const ItemsRatio: FCX<{
    form: UseFormReturn<BodyUpdateSurvey>;
}> = ({
    form: {
        state: { itemsRatio },
        actions
    }
}) => {
    if (itemsRatio === undefined) {
        return null;
    }

    return (
        <>
            <div className="SurveyDetails__spacer"></div>
            <div className="SurveyDetails__param-column">
                <div className="SurveyDetails__section-title">Quotas by Concept Type</div>
                {CONFIG.map((config) => (
                    <div  key={config.key} className="SurveyDetails__param-row">
                        <div className="SurveyDetails__param-title">{config.title}</div>
                        <div className="SurveyDetails__param-value text-input">
                            <TextInput
                                type={TextInputType.NUMBER}
                                value={`${itemsRatio[config.key] ?? ''}`}
                                setValue={(v) => actions.setNestedField(`itemsRatio.${config.key}`, v)}
                                isSmall
                            />
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default ItemsRatio;
